import React, { useEffect, useState } from "react";
import "./App.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import {
  Box,
  Container,
  CssBaseline,
  ThemeProvider,
  Typography,
} from "@mui/material";
import createBabelTheme from "./theme";
import { Settings, defaultSettings } from "./types";
import { SettingsContext, LangChangeContext } from "./contexts";
import SettingsPanel from "./components/SettingsPanel";
import CheckboxList from "./components/CheckboxList";

export default function ThemedAppWrapper() {
  const [langChangeUseEffect, setLangChangeUseEffect] = useState(true);
  const [settings, setSettings] = useState<Settings>(() => {
    const storedSettings = localStorage.getItem("user-settings");
    return storedSettings ? JSON.parse(storedSettings) : defaultSettings;
  });

  React.useEffect(() => {
    localStorage.setItem("user-settings", JSON.stringify(settings));
  }, [settings]);

  const [theme, setTheme] = useState(createBabelTheme(settings.darkMode));

  useEffect(() => {
    setTheme(createBabelTheme(settings.darkMode));
  }, [settings.darkMode]);

  return (
    <SettingsContext.Provider value={{ settings, setSettings }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LangChangeContext.Provider
          value={{ langChangeUseEffect, setLangChangeUseEffect }}
        >
          <App />
        </LangChangeContext.Provider>
      </ThemeProvider>
    </SettingsContext.Provider>
  );
}

function App() {
  return (
    <Container maxWidth="md">
      <Box sx={{ my: 4 }} alignItems="center" justifyContent="center">
        <Typography variant="h4" component="h1" gutterBottom textAlign={"center"}>
          Babel List
        </Typography>
        <SettingsPanel />
        <CheckboxList />
      </Box>
    </Container>
  );
}
